import React, {useMemo, useState} from "react";
import {Tooltip} from "@mui/material";

import {CONTENT_TYPE_ICON_MAP} from "../../domain/ContentTypes";

const UNKNOWN_TYPE_INDEX = 0;
const DEFAULT_ICON_SIZE = 22;
const DEFAULT_ICON_COLOR = "#666";

export default function ContentTypeIcon({contentType, iconSize = DEFAULT_ICON_SIZE, iconColor = DEFAULT_ICON_COLOR}) {

    const [contentTypeName, setContentTypeName] = useState("");
    const [contentTypeIcon, setContentTypeIcon] = useState("");

    useMemo(() => {

        if (contentType) {
            const filteredContentType = CONTENT_TYPE_ICON_MAP.filter(contents => contents.key === contentType || contents.name === contentType);
            let icon = CONTENT_TYPE_ICON_MAP[UNKNOWN_TYPE_INDEX].icon;
            let name = CONTENT_TYPE_ICON_MAP[UNKNOWN_TYPE_INDEX].name;

            if (filteredContentType.length > 0) {
                name = filteredContentType[0].name;
                icon = filteredContentType[0].icon;
            }

            setContentTypeName(name);
            setContentTypeIcon(icon);
        }
    }, [contentType]);

    return <>
            {contentTypeName !== ""
              && <Tooltip title={contentTypeName}>
                  {React.cloneElement(contentTypeIcon, {sx: {fontSize: iconSize, color: iconColor}})}
            </Tooltip>}
        </>;
}
